import { EmoteVis } from "@/animations/Emote";
import { canv } from "@/canv/global";
import type { ZoomToVis } from "./ZoomToVis";

export class Animator {
    draw() {
        for (let i = 0; i < this.animations.length; i++) {
            this.animations[i].draw();
        }
    }

    step() {
        for (let i = 0; i < this.animations.length; i++) {
            if (this.animations[i].finished) {
                this.animations.splice(i, 1);
                i--;
                continue;
            }
            this.animations[i].step();
        }
    }

    frame() {
        this.draw();
        this.step();
    }

    isEmpty() {
        return this.animations.length === 0;
    }

    addAnimation(animation: EmoteVis | ZoomToVis) {
        this.animations.push(animation);
    }

    hasAnimation(name: string) {
        for (let i = 0; i < this.animations.length; i++) {
            if (this.animations[i].name === name) {
                return true;
            }
        }

        return false;
    }

    deleteAnimation(name: string) {
        for (let i = 0; i < this.animations.length; i++) {
            if (this.animations[i].name === name) {
                this.animations.splice(i, 1);
                i--;
            }
        }
    }

    createEmote(data: AnimatorCreateEmoteProps) {
        const emot = new EmoteVis(data.x, data.y, data.url);

        canv.animator.addAnimation(emot);
    }

    animations: Array<EmoteVis | ZoomToVis> = [];
}

export type AnimatorCreateEmoteProps = {
    x: number;
    y: number;
    url: string;
};
